import { Component, OnInit, Input } from '@angular/core';
import { OPCConstant } from '../../../opc-app/opc.const';
import { OPCSettings } from '../../models/opcsettings.model';

@Component({
    selector: 'app-card-view',
    templateUrl: './cardview.component.html',
    styleUrls: ['./cardview.component.css']
})
export class CardViewComponent implements OnInit {
    @Input() viewData: any;
    defaultImage: string;
    opcSettings: OPCSettings = new OPCSettings();
    blobImgURL: string;
    constructor() { }
    ngOnInit() { }
    errorImage(event) {
        //event.target.src = this.defaultImage;
    }
}



// WEBPACK FOOTER //
// ./src/opc/shared/components/cardview/cardview.component.ts